import { timezoneOffsetMillis } from '@/constants/global';
export default {
    authId: (state) => state.data.authId,
    serialNumber: (state) => state.data.serialNumber,
    expiredAt: (state) => state.data.expiredAt + timezoneOffsetMillis,
};
